import { inject } from '@angular/core';
import { AdminUsersFiltersModel } from '../../../models';
import { Observable } from 'rxjs';
import { AdminUsersFiltersStorage } from '@admin-panel/infra';

export class PatchAdminUsersFiltersCommandHandler {
  private readonly adminUsersFiltersStorage: AdminUsersFiltersStorage = inject(AdminUsersFiltersStorage);

  patch(data: Partial<AdminUsersFiltersModel>): Observable<void> {
    return this.adminUsersFiltersStorage.patchContext(data);
  }

  reset(): Observable<void> {
    return this.adminUsersFiltersStorage.patchContext({
      search: ''
    });
  }
}
